<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';

   export default {
      page: {
         title: "Requests",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const datetime_now = moment().format("YYYY-MM-DD HH:mm:ss");
         return {
            title: "Requests",
            items: [
               {
                  text: "Requests",
                  active: true,
               },                   
            ],

            requests: [],          
            from: null,
            to: null,
            total: null,
            pagination: {},

            listing_length: 10,
            keyword: '',
            order_status: "",
            token: "",
            errors: {},          
            active_page_url: null,

            confirm: {
               request_id: '',
               amount: ''
            },
            now: datetime_now,

         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchRequests();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
         fetchRequests(page_url = null) {

            this.getToken();
            let url = "api/admin/pharmacy/requests?keyword=" + this.keyword + "&limit=" + this.listing_length;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.requests = responseData.pharmacy_request.data;
                  
                  this.pagination = responseData.pharmacy_request.links;
                  this.from = responseData.pharmacy_request.from;
                  this.to = responseData.pharmacy_request.to;
                  this.total = responseData.pharmacy_request.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },   

         confirmRequest(request) {
            this.confirm.request_id = request.order_id;

            this.showModal('confirm-modal');

         },
         cancelOrder(order_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to cancel this order?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                 
                  let url = "api/admin/pharmacy/orders/cancel?order_id=" + order_id;
                  this.$axios
                  .get(url, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchRequests(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },


         makeOrder() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/pharmacy/request_confirm";

            let formData = new FormData();
            formData.append("request_id", this.confirm.request_id); 
            formData.append("amount", this.confirm.amount); 
            
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('confirm-modal');
                  this.fetchRequests(this.active_page_url);
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 

         clearForm() {
            this.confirm.request_id = '';
            this.confirm.amount = '';

            this.errors = {};
         },

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchRequests()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchRequests()"/>
                           </label>
                        </div>         
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>ID</th>
                              <th>Patient</th>              
                              <th>Contact</th>              
                              <th>Created on</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(requests.length)">
                           <tr v-for="(request) in requests" :key="request.id">
                              <td>{{request.order_id}}</td>
                              <td>{{request.name}}</td>                       
                              <td>
                                 <span v-if="request.order_phone">
                                    {{request.order_country_code}} {{request.order_phone}}<br>
                                    {{request.email}}<br>
                                 </span>
                                 <span v-else>
                                    {{request.profile_country_code}} {{request.profile_phone}}<br>
                                    {{request.email}}<br>
                                 </span>
                              </td>
                              <td>{{request.converted_created_at}}</td>
                              <td>
                                 <router-link :to="{ name: 'pharmacy.requests.details' , params: {id: request.order_id}}" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link> 
                                 <button @click="cancelOrder(request.order_id)" class="btn btn-danger me-2 mb-2 btn-sm" type="button" >Cancel</button>
                                 <b-button variant="success" class="me-2 mb-2 btn-sm" @click="confirmRequest(request)" v-if="request.status != 6">Confirm</b-button>
                              </td>
                           </tr>
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No requests found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(requests.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchRequests(page.url + '&limit='+ listing_length + '&keyword=' + keyword )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->   

               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <b-modal ref="confirm-modal" id="confirm-modal" title="Confirm Request" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="makeOrder()">
            <b-row>  

               <b-col lg="12" class="form-group">
                  <label class="control-label">Amount<span class="text-danger">*</span></label>
                  <b-form-input  v-model="confirm.amount" min="0" v-bind:class="{ 'is-invalid': Boolean(errors.amount) }"></b-form-input>
                  
                  <div v-for="(val, index) in errors.amount" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>              
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                  <b-button class="" variant="light" @click="hideModal('confirm-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
